import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControl } from '../../base/base-control';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { BaseFormControl } from '../../base/base-form-control.directive';


@Component({
    selector: 'app-number-input',
    standalone: true,
    templateUrl: './number-input.component.html',
    styleUrl: './number-input.component.scss',
    imports: [CommonModule]
})
export class NumberInputComponent extends BaseFormControl<string> {
  baseImagePath = 'assets/images/';
}
